export const GROUPING = {
    MONTHLY: 'MONTHLY',
    WEEKLY: 'WEEKLY',
    QUARTERLY: 'QUARTERLY',
};

export const FISCAL_PERIOD_TYPE = {
    PREDEFINED: 'predefined',
    CUSTOM: 'custom',
};
